<script>
	import { browser } from '$app/environment';
	import dollar from '$lib/assets/images/icons/dollar.svg';
	import { Marquee } from '$lib/components/Global/Marquee';
	import __ from '$lib/stores/TranslationStore';

	export let data;
	let { eur3, eur6, eur12, mixed } = data?.data || {};
</script>

<div class="overflow-hidden bg-secondary text-sm text-white 2xl:text-nav">
	<Marquee class="h-14 gap-16" speed="30s">
		{#if eur3 || eur6 || eur12 || mixed}
			{#each { length: 4 } as _, i}
				<div class="flex items-center gap-16 uppercase">
					<span>{$__('Taxas de referência para Crédito Hipotecário')}</span>
					{#if eur3}
						<span>EURIBOR 3M {eur3}%</span>
					{/if}
					{#if eur6}
						<span>EURIBOR 6M {eur6}%</span>
					{/if}
					{#if eur12}
						<span>EURIBOR 12M {eur12}%</span>
					{/if}
					{#if mixed}
						<span>{$__('Taxa mista a partir de')} {mixed}%</span>
					{/if}
					<span><img class="h-[25px] w-[27px]" src={dollar} alt="Euribor" /></span>
				</div>
			{/each}
		{/if}
	</Marquee>
</div>
